import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { DocumentUploadFileInput } from '@monorepo/shared/componentsV2/documents/DocumentUploadFileInput';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { Search } from '@monorepo/shared/componentsV2/Search';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useUploadSiteDocuments } from '../../hooks/useUploadSiteDocuments';

const SearchContainer = styled.div`
  max-width: 10rem;
`;

interface SiteDocumentsHeaderProps {
  organizationId: string;
  projectId: string;
  filter: string;
  onSearch: (search: string) => void;
  canEditSiteDocuments: boolean;
}

export function SiteDocumentsHeader({
  organizationId,
  projectId,
  filter,
  onSearch,
  canEditSiteDocuments,
}: SiteDocumentsHeaderProps) {
  const [upload, { status }] = useUploadSiteDocuments({
    config: { throwOnError: true },
  });
  const isUploading = status === 'loading';

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onSearch(e.target.value),
    [onSearch],
  );

  const onUpload = useCallback(
    (files: File[]) => upload({ organizationId, projectId, files }),
    [organizationId, projectId, upload],
  );

  return (
    <Header
      title="Documents"
      variant="noDropShadow"
      rightActions={
        <ButtonsGroup>
          <SearchContainer>
            <Search onChange={handleSearch} value={filter} />
          </SearchContainer>
          {canEditSiteDocuments && (
            <DocumentUploadFileInput
              inputId="site-documents-upload"
              uploadButtonText="Add document"
              isUploading={isUploading}
              onUpload={onUpload}
            />
          )}
        </ButtonsGroup>
      }
    />
  );
}
